// @flow

// TODO Reorder names, backwards
export const PHISHING_SCORE_VALUES = {
  UNRESOLVED: 'UNRESOLVED',
  CONFIRMED: 'CONFIRMED',
  IGNORED: 'IGNORED',
};

export const TRIAGE_STATUSES = {
  UNKNOWN: -1,
  BENIGN: 0,
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
};

export const TRIAGE_STATUSES_TO_NAMES = {
  '-1': 'UNKNOWN',
  '0': 'BENIGN',
  '1': 'LOW',
  '2':  'MEDIUM',
  '3': 'HIGH',
};


export const TRIAGE_STATUS_OPTIONS = Object.values(TRIAGE_STATUSES);
export const PHISHING_STATUS_OPTIONS = Object.values(PHISHING_SCORE_VALUES);

export const SUMMARY_SERVICE_ENDPOINT = '/services/entity-reports/summaries';
export const REPORT_METADATA_SERVICE_ENDPOINT =
  ' /services/incident-reports/metadata/v2';

export const REPORTS_ENDPOINT = '/services/incident-reports';
export const TRIAGE_ENDPOINT = '/services/triage/submissions';

export const DOWNLOAD_INDICATOR_CSV_ENDPOINT = '/services/triage/export-indicators.csv';
export const PHISHING_INDICATORS_CSV_FILENAME = 'phishing-report.csv';


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/hooks/constants.js